var site = site || {};
site.Navigation = (function () {
    
    const disableNavDropdownClicks = () => {
        const navDropdowns = document.querySelectorAll('.js-nav-dropdowns');
        navDropdowns.forEach((navDropdown) => {
            navDropdown.addEventListener('click', (target) => {
                target.stopPropagation()
            })
        });
    }
    
    function subnavContentInit(mediaQueries) {
        const subNavs = document.querySelectorAll('.js-dropdown-menu');
        
        subNavs.forEach((subnav) => {
            // Set first subnav item and content as active on initial pageload
            const navItems = subnav.querySelectorAll('.js-subnav-link');
            const navContent = subnav.querySelectorAll('.js-subnav-content');
            navItems[0].classList.add('active');
            navContent[0].classList.remove('d-none');
            
            // Subnav Item Click Handling
            navItems.forEach((item) => {
                item.addEventListener('click', function(event) {
                    event.preventDefault();
                    
                    const navId = item.getAttribute('data-subnav-id');
                    
                    navItems.forEach((navItem) => {
                        navItem.classList.remove('active');
                    })
                    
                    item.classList.add('active');
                    
                    navContent.forEach((section) => {
                        let sectionId = section.getAttribute('data-subnav-content-id')
                        if (sectionId == navId) {
                            section.classList.remove('d-none');
                        }
                        else {
                            section.classList.add('d-none');
                        }
                    });
                })
            });
        })
    };

    return {
        disableNavDropdownClicks : disableNavDropdownClicks,
        subnavContentInit : subnavContentInit
    };

}());